<template>
  <div
    :class="{ 'has-logo': showLogo, 'left-nav': true }"
    style="display: flex; flex-direction: column">
    <div class="scrollbarLogo">
      <img
        :src="styleTheme.table === 'table_maomao_1' ? logoW : logoB"
        :style="sidebar.opened ? 'margin-right:0px;' : ''"
        v-if="!isCollapse" />
      <img
        :src="styleTheme.table === 'table_maomao_1' ? minlogoW : minlogo"
        :style="sidebar.opened ? 'margin-right:0px;' : ''"
        v-else
        class="minlogo" />
      <!--            <img src="@/assets/gaiban/logo_text.png" v-if="sidebar.opened" />-->
    </div>
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="
          !styleTheme.menuBg || styleTheme.menuBg === '1'
            ? variables.menuBg
            : variables.menuBgWhite
        "
        :text-color="
          !styleTheme.menuBg || styleTheme.menuBg === '1'
            ? variables.menuText
            : variables.menuTextWhite
        "
        :unique-opened="false"
        :active-text-color="yanse"
        :collapse-transition="false"
        mode="vertical"
        ref="menu">
        <!--        <sidebar-item v-for="route in leftMenuList" :key="route.path" :item="route"-->
        <!--          :base-path="route.path" />-->
        <el-submenu
          v-for="(route, index) in leftMenuList"
          :key="index"
          :index="resolvePath(route.path)"
          style="position: relative">
          <!--  :class="index == 0 ? 'jianbian-el-menu-po' : ''"-

           :style="
            styleTheme.menuBg &&
            styleTheme.menuBg === '2' &&
            sidebar.opened &&
            '/' + activeMenu.toString().split('/')[1].split('/')[0] ===
              route.path
              ? jianbian
              : ''
          "
          -->
          <template slot="title">
            <!--            <div-->
            <!--              class="jianbian-el-menu"-->
            <!--              style="top: -20px"-->
            <!--              v-if="styleTheme.menuBg && styleTheme.menuBg === '2'"></div>-->
            <!-- 显示图标 -->
            <i
              v-if="route.meta.icon && !route.meta.src"
              :class="
                route.meta.icon
                  ? 'iconfont sub-el-icon ' + route.meta.icon
                  : 'iconfont sub-el-icon'
              "
              :style="
                route.path.indexOf('fang-wei') != -1
                  ? 'color:orange'
                  : route.path.indexOf('product-manager') != -1
                  ? 'color:#a6d6d5'
                  : route.path.indexOf('performance') != -1
                  ? 'color:#6184f7'
                  : route.path.indexOf('finance-manager') != -1
                  ? 'color:#f63734'
                  : ''
              " />
            <img
              :class="[
                'iconfont',
                route.meta.right ? 'sub-el-icon-1' : 'sub-el-icon',
              ]"
              :style="
                route.meta.width ? route.meta.width : 'width: 16px !important'
              "
              v-if="route.meta.icon && route.meta.src"
              :src="route.meta.src" />

            <!--                        <span v-if="route.meta.icon&&!route.meta.src">-->
            <!--                               <i-->
            <!--                                       :class="'iconfont sub-el-icon' + route.meta.icon-->
            <!--              " />-->
            <!--                        </span>-->
            <!--                        <span v-if="route.meta.icon&&route.meta.src">-->
            <!--             <img style="width: 15px" :src="route.meta.src"/>-->
            <!--           </span>-->

            <!-- 显示菜单标题 -->
            <span style="font-family: auto" :style="route.meta.spanL">
              {{ route.meta.title }}
            </span>
            <div
              class="shuxian_m"
              :style="'background:' + yanse + ';'"
              v-if="
                sidebar.opened &&
                '/' + activeMenu.toString().split('/')[1].split('/')[0] ===
                  route.path
              "></div>
          </template>
          <!-- 处理子路由 -->
          <template v-if="route.children && route.children.length">
            <el-menu-item-group>
              <template v-for="(child, childIndex) in route.children">
                <el-menu-item :index="resolvePath(child.path, route.path, 1)">
                  <AppLink
                    :to="resolvePath(child.path, route.path, 1)"
                    :base="route.path"
                    style="display: flex">
                    <span style="width: 16px">
                      <i
                        :class="
                          child.meta.icon
                            ? 'iconfont sub-el-icon ' + child.meta.icon
                            : 'iconfont sub-el-icon'
                        " />
                    </span>
                    <span
                      :style="
                        child.path === contentUrl ? 'color:' + yanse + ';' : ''
                      "
                      style="font-family: auto; flex: 1">
                      {{ child.meta.title }}
                    </span>
                  </AppLink>
                </el-menu-item>
              </template>
            </el-menu-item-group>
          </template>
        </el-submenu>
      </el-menu>
    </el-scrollbar>
    <div class="ertghu">
      <hamburger
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar" />
    </div>
  </div>
</template>

<script>
import minPng from "@/assets/gaiban/logo_min.png";
import minPngW from "@/assets/gaiban/logo_min_w.png";
import logoPng from "@/assets/gaiban/logo.png";
import logoWPng from "@/assets/gaiban/logow.png";
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import AppLink from "./Link";
import variables from "@/styles/variables.scss";
import { isExternal } from "../../../utils/validate";
import path from "path";
import Hamburger from "@/components/Hamburger";

export default {
  components: { SidebarItem, Logo, AppLink, Hamburger },
  data() {
    return {
      minlogo: minPng,
      minlogoW: minPngW,
      logoB: logoPng,
      logoW: logoWPng,
      activeTaghj1: "",
      activeTaghj: "",
      hasOpened: false,
      hasOpened1: false,
      yanse: "",
      jianbian: "",
      contentUrl: "",
      preUrl: "",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        console.log(route.fullPath + "产品管理555555555555555555打开");
        const parts = route.fullPath.split("/").filter(Boolean); // 分割并过滤空字符串
        const [module, subModule] = parts; // 解构赋值获取两个部分
        console.log(module); // 输出: internet-manager
        console.log(subModule); // 输出: deviceModelManagement
        this.preUrl = module;
        this.contentUrl = subModule;
        if (route.fullPath.indexOf("clientManagement") != -1) {
          //产品
          this.yanse = "#599b70";
          this.jianbian =
            "background: linear-gradient(90deg, #599b70 0%, rgba(255,255,255,1) 80%, #eee 100%);";
          // this.ifUrl=
        } else if (route.fullPath.indexOf("useManagement") != -1) {
          //产品
          this.yanse = "#5185f0";
          this.jianbian =
            "background: linear-gradient(90deg, #5185f0 0%, rgba(255,255,255,1) 80%, #eee 100%);";
          // this.ifUrl=
        } else if (route.fullPath.indexOf("internet") != -1) {
          //设备
          this.yanse = "#55BBBC";
          //#55bbbc
          this.jianbian =
            "background: linear-gradient(90deg, #baeded 0%, rgba(255,255,255,1) 80%, #eee 100%);";
        } else if (route.fullPath.indexOf("commodityClassify") != -1) {
          //客户管理
          this.yanse = "#d44f8e";
          this.jianbian =
            "background: linear-gradient(90deg, #d44f8e 0%, rgba(255,255,255,1) 80%, #eee 100%);";
        } else if (route.fullPath.indexOf("staffManagement") != -1) {
          //员工管理
          this.yanse = "#f2d34f";
          this.jianbian =
            "background: linear-gradient(90deg, #f2d34f 0%, rgba(255,255,255,1) 80%, #eee 100%);";
        } else if (route.fullPath.indexOf("configuration") != -1) {
          //品牌
          this.yanse = "#7c7494";
          this.jianbian =
            "background: linear-gradient(90deg,#7c7494 0%, rgba(255,255,255,1) 80%,#eee 100%);";
        } else if (route.fullPath.indexOf("fang-wei") != -1) {
          //防伪
          this.yanse = "orange";
        } else if (route.fullPath.indexOf("notification") != -1) {
          //防伪
          this.yanse = "#793b50";
          this.jianbian =
            "background: linear-gradient(90deg, #793b50 0%, rgba(255,255,255,1) 80%, #eee 100%);";
        } else if (route.fullPath.indexOf("shuju-daing") != -1) {
          //防伪
          this.yanse = "#bda6e3";
          this.jianbian =
            "background: linear-gradient(90deg, #e9cef4 0%, rgba(255,255,255,1) 80%, #eee 100%);";
        } else if (route.fullPath.indexOf("performance") != -1) {
          this.yanse = "#6184f7";
        } else if (route.fullPath.indexOf("finance-manager") != -1) {
          this.yanse = "#f63734";
        } else if (route.fullPath.indexOf("operations-management") != -1) {
          this.yanse = "#774543";
          this.jianbian =
            "background: linear-gradient(90deg, #f3c8c6 0%, rgba(255,255,255,1) 80%, #eee 100%);";
        } else if (route.fullPath.indexOf("operationModule") != -1) {
          this.yanse = "#0c7963";
        }

        setTimeout(() => {
          var divsUnderClassA1 = [];
          var divsUnderClassA = [];
          console.log("路透变化shuaxinTotal" + route.fullPath);
          var elementsWithClassA = document.querySelectorAll(".table_maomao");
          if (elementsWithClassA) {
            // 遍历这些元素，为每个元素找到第一个子div

            elementsWithClassA.forEach(function (element) {
              var firstDiv = element.querySelector("div"); // 找到每个元素下的第一个div
              if (firstDiv) {
                divsUnderClassA.push(firstDiv); // 如果找到，添加到数组中
              }
            });
          }

          var elementsWithClassA1 =
            document.querySelectorAll(".table_maomao_1");
          if (elementsWithClassA1) {
            // 遍历这些元素，为每个元素找到第一个子div

            elementsWithClassA1.forEach(function (element) {
              var firstDiv1 = element.querySelector("div"); // 找到每个元素下的第一个div
              if (firstDiv1) {
                divsUnderClassA1.push(firstDiv1); // 如果找到，添加到数组中
              }
            });
          }

          this.$nextTick(() => {
            if (divsUnderClassA.length > 0) {
              var firstEle = divsUnderClassA[0];
              if (firstEle.className.toString().indexOf("el-table") != -1) {
                console.log("elements元素元素");
                firstEle.style.height = "100%";
                firstEle.style.overflow = "hidden";
                console.log(firstEle.style);
              } else {
                console.log("elements元素元素");
                console.log(firstEle);
                firstEle.style.height = "100%";
                firstEle.style.overflow = "scroll";
                console.log(firstEle.style);
              }
            }
            if (divsUnderClassA1.length > 0) {
              console.log("白色主题");
              console.log(divsUnderClassA1[0]);
              var firstEle1 = divsUnderClassA1[0];
              if (firstEle1.className.toString().indexOf("el-table") != -1) {
                console.log("elements元素元素");
                firstEle1.style.height = "100%";
                firstEle1.style.overflow = "hidden";
                console.log(firstEle1.style);
              } else {
                console.log("elements元素元素");
                console.log(firstEle1);
                firstEle1.style.height = "100%";
                firstEle1.style.overflow = "scroll";
                console.log(firstEle1.style);
              }
            }
          });
        }, 1000);
      },
      immediate: true,
    },
  },
  created() {
    // treeResource()
    console.log(this.$router.options.routes);
  },
  computed: {
    ...mapGetters(["sidebar", "leftMenuList", "styleTheme"]),
    routes() {
      return this.$router.options.routes;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods: {
    goDaPing() {
      //this.$router.push("/daping2");
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    handleOpen(index, indexPath) {
      console.log("子菜单展开，索引: ", index);
      console.log("子菜单展开，索引路径: ", indexPath);
    },
    clickShow() {
      console.log("点");
      this.hasOpened = !this.hasOpened;
    },
    clickShow1() {
      this.hasOpened = true;
      this.hasOpened1 = !this.hasOpened1;
    },
    resolvePath(routePath, base, type, bahu) {
      // console.log(this.leftMenuList);

      // 确保 routePath 是字符串类型
      if (typeof routePath !== "string") {
        routePath = String(routePath);
      }

      if (isExternal(routePath)) {
        return routePath;
      }
      // 确保 this.basePath 存在且是字符串类型
      if (this.basePath && typeof this.basePath !== "string") {
        this.basePath = String(this.basePath);
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      console.log(bahu != null ? base + bahu + routePath : "");
      if (bahu != null) {
        return type != null
          ? base + "/" + bahu
            ? path.resolve(base + "/" + bahu, routePath)
            : routePath
          : this.basePath
          ? path.resolve(this.basePath, routePath)
          : routePath;
      } else {
        return type != null
          ? base
            ? path.resolve(base, routePath)
            : routePath
          : this.basePath
          ? path.resolve(this.basePath, routePath)
          : routePath;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.iconfont {
  width: 16px !important;
}
.customerMenu_item {
  padding-left: 60px;
  width: calc(100% - 20px);
  height: 50px;
  line-height: 40px;
  display: flex;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  align-items: center;
  justify-content: space-between;
  ::v-deep .el-icon-arrow-down {
    width: 7px;
    font-size: 0.7rem;
    opacity: 0.6;
  }
  ::v-deep .el-icon-arrow-up {
    width: 7px;
    font-size: 0.65rem;
    opacity: 0.6;
  }
}
.left-nav {
  width: 288px;
}
::v-deep {
  .el-menu-item-group__title {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
  }
  .el-submenu__title {
    height: auto !important;
  }
}
.hamburger-container {
  line-height: 46px;
  // height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;
  position: absolute;
  width: calc(100% - 48px);
  bottom: 10px;
  left: 39px;
  border-radius: 4px;
  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
.scrollbarLogo {
  height: 84px;
}
.minlogo {
  height: 34px !important;
  margin-left: 19px;
}
</style>
